(() => {
  const init = () => document.querySelectorAll('.bg-tattoo-gallery').forEach(root => {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const links = Array.from(root.querySelectorAll('.bg-tattoo-photo'));
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const image = dialog.querySelector('img');
    const count = dialog.querySelector('[aria-live]');
    let current = 0;
    const show = index => {
      current = (index + links.length) % links.length;
      image.src = links[current].href;
      image.alt = links[current].querySelector('img').alt;
      count.textContent = `${current + 1} / ${links.length}`;
    };
    links.forEach((link,index) => link.addEventListener('click', event => {
      event.preventDefault(); show(index); dialog.showModal();
    }));
    dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => show(current - 1));
    dialog.querySelector('[data-gallery-next]').addEventListener('click', () => show(current + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    });
    dialog.addEventListener('close', () => links[current].focus());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
